var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMeat = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 497 497",
    height: 512,
    viewBox: "0 0 497 497",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m415.109 165.513c40.902-71.222 55.592-165.513 55.592-165.513l26.299.1s-12.968 114.849-41.135 182.525l-30.616 9.831z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.95 162.928 46.915 19.697c8.116 3.408 12.296 12.441 9.611 20.819-16.679 52.051-84.202 225.448-258.355 284.563-47.692 16.189-112.473 13.232-159.68-31.459-45.347-42.931-50.573-105.559-46.183-152.974 3.268-35.293 36.314-60.168 71.166-53.587 90.27 17.047 229.5 24.614 316.888-82.097 4.754-5.805 12.717-7.868 19.638-4.962z",
    fill: "#ffd8d5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m455.865 182.625-46.915-19.697c-6.921-2.906-14.884-.843-19.638 4.963-.736.899-1.484 1.768-2.228 2.651l28.781 12.084c8.117 3.408 12.296 12.441 9.611 20.819-16.679 52.051-84.202 225.448-258.355 284.563-10.86 3.686-22.607 6.375-34.83 7.81 26.318 3.166 52.455-.215 74.83-7.81 174.153-59.115 241.677-232.512 258.355-284.563 2.685-8.38-1.494-17.413-9.611-20.82z",
    fill: "#f4c3c6"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#e5646e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m156.443 461.85c-53.592-.204-91.375-30.595-108.158-65.879-4.914-10.33-7.72-20.47-9.322-28.753-1.83-9.461 6.321-17.849 15.846-16.386 61.375 9.428 135.361 15.519 193.691 2.668 25.649-5.651 50.382 15.549 61.2 26.568 3.343 3.405 3.309 8.893-.149 12.181-32.699 31.089-103.962 69.788-153.108 69.601z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.928 331.536c21.935-28.118 55.42-74.088 68.241-107.876 2.904-7.653-1.35-16.144-9.241-18.338-5.151-1.432-10.668.209-14.176 4.24-22.512 25.87-118.123 116.271-331.321 81.898-8.378-1.351-16.233 4.434-17.361 12.839-1.071 7.983 4.335 15.398 12.271 16.805 31.241 5.54 109.495 16.491 187.147 4.216 17.699-2.798 35.811.826 50.954 10.399 2.098 1.326 4.227 2.672 6.341 4.008 15.488 9.792 35.878 6.252 47.145-8.191z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMeat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/meat.bff66b38.svg";
export { ForwardRef as ReactComponent };